/**
 * curdQueryStore
 * 编辑页面共用逻辑以及部分子组件与父组件通讯
 */
import orderBackCountUtil from '../../static/js/backCountUtils/orderBackCountUtil'
import sheetsBackCountUtil from '../../static/js/backCountUtils/sheetsBackCountUtil'
import priceControlBackCountUtil from '../../static/js/backCountUtils/priceControlBackCountUtil'

class CurdQueryStore {
  constructor(curdQuery, initialState = {}, initialMutations, initialActions) {
    this.curdQuery = curdQuery

    //状态数据
    this.states = {
      formData: null,
      //页面切换时不需缓存的数据
      provisional: {},
    }

    //修改states的方法
    this.mutations = {
      setFormData(states, data) {
        this.states.formData = data
      },
    }
    //操作方法
    this.actions = {
      //触发单据类的反算
      orderBackCountUtil(states, field, ...args) {
        if (orderBackCountUtil[field] && typeof orderBackCountUtil[field] == 'function') {
          return orderBackCountUtil[field](...args)
        }
      },
      //触发价格管理的反算
      priceControlBackCountUtil(states, field, ...args) {
        if (
          priceControlBackCountUtil[field] &&
          typeof priceControlBackCountUtil[field] == 'function'
        ) {
          return priceControlBackCountUtil[field](...args)
        }
      },
      //触发打印侧滑表格反算：bug36358
      sheetsBackCountUtil(context, field, ...args) {
        if (sheetsBackCountUtil[field] && typeof sheetsBackCountUtil[field] == 'function') {
          return sheetsBackCountUtil[field](...args)
        }
      },
      //用于判断计算工具类中是否存在该方法
      //utilName计算工具类的名字
      ifBackCountUtil(utilName, key) {
        if (utilName == 'orderBackCountUtil' && orderBackCountUtil[key]) {
          return true
        } else if (utilName == 'priceControlBackCountUtil' && priceControlBackCountUtil[key]) {
          return true
        } else {
          return false
        }
      },
    }

    //初始赋值自定义state
    for (let prop in initialState) {
      if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (initialMutations.hasOwnProperty(prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (initialActions.hasOwnProperty(prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default CurdQueryStore
